module.exports = __webpack_public_path__ + "img/vvp.998b484b.png";